import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Toaster, ModuleFE_WindowMessenger, ModuleFE_XHR, SimpleListAdapter, stopPropagation, StorageKey, TS_DropDown, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { Key_AdvisorMountedMessage, Key_CloseActivity, Key_UpdateOrdersMessage } from '../Page_Advisor/index.js';
import { Advisor_UserType_SBFHIRQuery, Advisor_UserType_SBNLP, Advisor_UserType_SBOrders, Default_EHRID, HeaderKey_AdvisorSessionId, UrlParam_EnvironmentId, UrlParam_FacilityId, UrlParam_UserType } from '@app/advisor-shared';
import './Page_Demo_NEW.scss';
import { AssertionException, BadImplementationException, deepClone, ImplementationMissingException, sortArray } from '@nu-art/ts-common';
import { ICONS, ResizableWrapper } from '@app/styles';
import { Demo_MockMiddlePanel } from './Demo_MockMiddlePanel.js';
import { ModuleFE_SmartOnFHIR } from '../../../modules/index.js';
import { Launcher_EHR } from './Launcher_EHR.js';
import { ModuleFE_AdvisorSession, ModuleFE_AdvisorSession_Class } from '../../../_entity/advisor-session/index.js';
import { ModuleFE_EMInterface } from '../../../_entity/runtime/em-interface/index.js';
export const defaultEHRId = Default_EHRID;
const getiFrameId = (patientId) => `internal-iframe-${patientId}`;
const storage_LastSelectedPatient = new StorageKey('last-selected-patient');
export class Page_Demo_NEW extends ComponentSync {
    //######################### Class Properties #########################
    receiver;
    iframeRef = React.createRef();
    messenger_setAdvisorEHRId = () => {
        if (!this.iframeRef.current)
            return;
        return ModuleFE_WindowMessenger.createMessenger(this.iframeRef.current.contentWindow);
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.openEncounters ??= [];
        state.selectedEnvironment ??= state.environments?.[0];
        state.selectedFacility ??= state.facilities?.[0];
        const patients = this.getAvailablePatients(state.selectedEnvironment, state.openEncounters);
        const storagePatient = storage_LastSelectedPatient.get();
        const storagePatientInPatients = storagePatient && patients.map(patient => patient.label).includes(storagePatient.label);
        state.selectedPatient = storagePatientInPatients ? storagePatient : patients[0];
        return state;
    }
    componentDidMount() {
        this.receiver.mount();
        this.loadEnvironments();
    }
    componentWillUnmount() {
        this.receiver.unmount();
    }
    constructor(props) {
        super(props);
        this.receiver = ModuleFE_WindowMessenger
            .createReceiver(window.origin)
            // .addProcessor(Key_ExpandWidthMessage, this.onWidthExpand)
            // .addProcessor(Key_SetAdvisorWidth, this.setAdvisorWidth)
            .addProcessor(Key_AdvisorMountedMessage, this.advisorIframeMounted)
            .addProcessor(Key_CloseActivity, () => {
            window.location.reload();
        })
            .addProcessor(Key_UpdateOrdersMessage, async () => {
            if (ModuleFE_AdvisorSession.hasSessionData()) {
                this.forceUpdate();
            }
        });
        ModuleFE_AdvisorSession_Class.IAMTHEFRAME = true;
    }
    //######################### Events #########################
    advisorIframeMounted = async (message) => {
        this.logInfo('Iframe Mounted', message);
        ModuleFE_XHR.addDefaultHeader(HeaderKey_AdvisorSessionId, () => message.sessionId);
        ModuleFE_EMInterface.startFirebaseListeners();
        setTimeout(() => this.forceUpdate(), 3000);
    };
    //######################### Logic #########################
    loadEnvironments = async () => {
        try {
            const environments = await ModuleFE_EMInterface.vv1.advisorUtils.getEMQuaiEnvironments({}).executeSync();
            const emFacilities = await ModuleFE_EMInterface.vv1.advisorUtils.getEMQuaiFacilities({}).executeSync() ?? [];
            const facilities = sortArray(emFacilities, facility => (facility.name?.toLowerCase().includes('quai') ? 0 : 1));
            this.reDeriveState({ facilities, environments });
        }
        catch (err) {
            ModuleFE_Toaster.toastError('Could not load Environments.');
        }
    };
    getAvailablePatients(environment = this.state?.selectedEnvironment, launchedPatients = this.state?.openEncounters) {
        const patients = environment?.demoPatients ?? [];
        if (!patients)
            return [];
        const launchedPatientIds = launchedPatients.map(patient => patient.patientId);
        //Filter patients that are already launched
        return patients.filter(patient => {
            const patientId = ('fhirPatient' in patient) ? patient.fhirPatient : patient.patientId;
            return !launchedPatientIds.includes(patientId);
        });
    }
    getCurrentlySelectedEncounter = () => {
        return this.state.openEncounters.find(encounter => encounter.patientId === this.state.currentlyOpenedTab_PatientId);
    };
    //######################### Logic - Launch #########################
    launchAssert_Environment = () => {
        const environment = this.state.selectedEnvironment;
        if (!environment) {
            ModuleFE_Toaster.toastError('Please select an Environment');
            throw new AssertionException('No Environment selected');
        }
        return environment;
    };
    launchAssert_Facility = () => {
        const facility = this.state.selectedFacility;
        if (!facility) {
            ModuleFE_Toaster.toastError('Please select an facility');
            throw new AssertionException('No facility selected');
        }
        return facility;
    };
    launchAssert_Patient = () => {
        const patient = this.state.selectedPatient;
        if (!patient) {
            ModuleFE_Toaster.toastError('Please select a patient');
            throw new AssertionException('No Patient selected');
        }
        return patient;
    };
    launchAssert_EpicPatient = () => {
        const patient = this.launchAssert_Patient();
        if (!('patientId' in patient)) {
            this.logError('Launching Epic with a non epic patient', patient);
            throw new BadImplementationException('Launching Epic with a non epic patient');
        }
        return patient;
    };
    launchAssert_DeployPatient = () => {
        const patient = this.launchAssert_Patient();
        if (!('fhirPatient' in patient)) {
            this.logError('Launching Epic with a non epic patient', patient);
            throw new BadImplementationException('Launching Epic with a non epic patient');
        }
        return patient;
    };
    launchAssert_MaxEncountersReached = () => {
        if (this.state.openEncounters.length >= ModuleFE_AdvisorSession.config.numOfEncountersToKeepInIDB) {
            ModuleFE_Toaster.toastError(`Cannot open more than ${ModuleFE_AdvisorSession.config.numOfEncountersToKeepInIDB} encounters simultaneously.`);
            throw new AssertionException('Max # of open encounters reached');
        }
    };
    launchImpl_Epic = async (userType) => {
        try {
            //Assert launch
            // const ehrInstance = this.launchAssert_EHRInstance();
            const environment = this.launchAssert_Environment();
            const facility = this.launchAssert_Facility();
            const patient = this.launchAssert_EpicPatient();
            this.launchAssert_MaxEncountersReached();
            //Get SRC
            const src = await ModuleFE_SmartOnFHIR.getSmartOnFhirLaunchUrl(patient.patientId, environment._id, facility._id, userType);
            //Create new demo encounter
            const demoEncounter = {
                src,
                patientId: patient.patientId,
                patientName: patient.label,
                isDeployIntegration: false,
            };
            this.reDeriveState({
                openEncounters: [...this.state.openEncounters, demoEncounter],
                message: undefined,
                currentlyOpenedTab_PatientId: patient.patientId,
            });
        }
        catch (err) {
            this.logError(err);
        }
    };
    launchImpl_Deploy = (userType) => {
        try {
            //Assert launch
            const { selectedEnvironment, selectedFacility } = this.state;
            const patient = this.launchAssert_DeployPatient();
            this.launchAssert_MaxEncountersReached();
            //Get SRC
            const userType = 'physician';
            const src = `${window.location.origin}/launch-deploy?${UrlParam_EnvironmentId}=${selectedEnvironment?._id}&${UrlParam_FacilityId}=${selectedFacility?._id}&${UrlParam_UserType}=${userType}`;
            //Generate Message
            const message = deepClone(patient);
            message.parentFrameUrl = window.origin;
            //Create new demo encounter
            const demoEncounter = {
                src,
                patientId: patient.fhirPatient,
                patientName: patient.label,
                isDeployIntegration: true,
            };
            this.reDeriveState({
                openEncounters: [...this.state.openEncounters, demoEncounter],
                message: undefined,
                currentlyOpenedTab_PatientId: patient.fhirPatient,
            });
            setTimeout(() => {
                return this.messenger_setAdvisorEHRId()?.sendMessage(message);
            }, 5000);
        }
        catch (err) {
            this.logError(err);
        }
    };
    launchEnvironment = async (userType = 'physician') => {
        const environment = this.launchAssert_Environment();
        switch (environment.type) {
            case 'epic':
                return this.launchImpl_Epic(userType);
            case 'deploy':
                return this.launchImpl_Deploy(userType);
            default:
                throw new ImplementationMissingException(`Missing implementation for launch of type ${environment.type}`);
        }
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { id: 'page-demo', children: [this.renderBackground(), this.renderHeader(), this.renderTabs(), this.renderPanels()] });
    }
    //######################### Render - Page Design #########################
    renderBackground = () => {
        return _jsxs("div", { className: 'page-demo__background', children: [_jsx("div", { className: 'blob', id: 'blob-1' }), _jsx("div", { className: 'blob', id: 'blob-2' }), _jsx("div", { className: 'blob', id: 'blob-3' }), _jsx("div", { className: 'blob', id: 'blob-4' }), _jsx("div", { className: 'blob', id: 'blob-5' })] });
    };
    renderHeader = () => {
        return _jsxs(LL_H_C, { className: 'page-demo__header', children: [_jsx("h1", { children: "EMR" }), _jsxs(LL_H_C, { className: 'page-demo__header__navigator', children: [_jsxs(LL_H_C, { className: 'page-demo__header__navigator-item', children: [_jsx(ICONS.demo_edManager.component, {}), "ED Manager"] }), _jsxs(LL_H_C, { className: 'page-demo__header__navigator-item', children: [_jsx(ICONS.demo_patient.component, {}), "Patient"] }), _jsxs(LL_H_C, { className: 'page-demo__header__navigator-item', children: [_jsx(ICONS.demo_myReports.component, {}), "My Reports"] }), _jsxs(LL_H_C, { className: 'page-demo__header__navigator-item', children: [_jsx(ICONS.demo_helpDesk.component, {}), "Help Desk"] })] }), _jsxs(LL_H_C, { className: 'page-demo__header__tail', children: [_jsx(ICONS.demo_print.component, {}), _jsx(ICONS.demo_lock.component, {}), _jsx("div", { className: 'page-demo__header__tail__button', onClick: () => {
                                this.messenger_setAdvisorEHRId()?.sendMessage({
                                    'EventName': 'Epic.Common.RequestToCloseApp',
                                    'EventArgs': {
                                        'ForceClose': false
                                    },
                                    'errorCodes': []
                                });
                            }, children: "Log Out" })] })] });
    };
    renderTabs = () => {
        return _jsxs(LL_H_C, { className: 'page-demo__tabs', children: [_jsxs(LL_H_C, { className: 'page-demo__tabs__icons', children: [_jsx(ICONS.demo_tabs1.component, {}), _jsx("div", { className: 'page-demo__tabs__icons-sep' }), _jsx(ICONS.demo_tabs2.component, {}), _jsx("div", { className: 'page-demo__tabs__icons-sep' }), _jsx(ICONS.demo_tabs3.component, { style: { width: '20px' } }), _jsx("div", { className: 'page-demo__tabs__icons-sep' }), _jsx(ICONS.demo_tabs4.component, { style: { width: '23px' } })] }), this.renderPatientTabs(), _jsx(LL_H_C, { className: 'page-demo__tabs__search', children: _jsx(ICONS.demo_tabs5.component, {}) })] });
    };
    renderPatientTabs = () => {
        const encounters = this.state.openEncounters;
        return _jsxs(_Fragment, { children: [encounters.length >= 1 && _jsxs(LL_H_C, { className: 'page-demo__tabs__tab', onClick: () => this.setState({ currentlyOpenedTab_PatientId: undefined }), children: [_jsx("div", { className: 'page-demo__tabs__tab-background' }), _jsx(ICONS.advisor_avn_add.component, { className: 'clear-patient' })] }), encounters.map(item => {
                    const className = _className('page-demo__tabs__tab', item.patientId === this.state.currentlyOpenedTab_PatientId && 'selected');
                    return _jsxs(LL_H_C, { className: className, onClick: event => this.setState({ currentlyOpenedTab_PatientId: item.patientId }), children: [_jsx("div", { className: 'page-demo__tabs__tab-background' }), _jsx(ICONS.demo_tabs2.component, {}), _jsx("div", { className: 'page-demo__tabs__tab-text', children: item.patientName }), _jsx(ICONS.x.component, { style: { width: '10px', height: '10px', marginLeft: '40px' }, onClick: event => {
                                    stopPropagation(event);
                                    const openEncounters = this.state.openEncounters;
                                    const foundIndex = this.state.openEncounters.findIndex(encounter => encounter.patientId === item.patientId);
                                    openEncounters.splice(foundIndex, 1);
                                    const openedPatient = item.patientId === this.state.currentlyOpenedTab_PatientId
                                        ? undefined
                                        : this.state.currentlyOpenedTab_PatientId;
                                    if (!openedPatient)
                                        this.logWarning('Removed encounter');
                                    const nextCurrentlyOpenedTab_PatientId = this.state.currentlyOpenedTab_PatientId === item.patientId
                                        ? undefined
                                        : this.state.currentlyOpenedTab_PatientId;
                                    this.setState({
                                        openEncounters,
                                        currentlyOpenedTab_PatientId: nextCurrentlyOpenedTab_PatientId
                                    });
                                    this.forceUpdate();
                                } })] }, item.patientId);
                })] });
    };
    renderPanels = () => {
        return _jsxs(LL_H_C, { className: 'page-demo__panels', children: [this.renderLeftPanel(), this.renderMiddlePanel(), this.renderRightPanel()] });
    };
    //######################### Render - Left Panel #########################
    renderLeftPanel = () => {
        const currentlySelectedEncounter = this.getCurrentlySelectedEncounter();
        return _jsxs(LL_V_L, { className: 'page-demo__panels__left', children: [_jsx(LL_H_C, { className: 'page-demo__panels__left__title', children: currentlySelectedEncounter && _jsxs(_Fragment, { children: [_jsx(ICONS.demo_patientName.component, {}), currentlySelectedEncounter.patientName] }) }), _jsxs(LL_V_L, { className: 'page-demo__panels__left__menu', children: [this.render_LeftPanel_EnvironmentDD(), this.render_LeftPanel_FacilityDD(), this.render_LeftPanel_PatientDD(), this.renderLeftPanelButtons()] })] });
    };
    render_LeftPanel_EnvironmentDD = () => {
        const environments = this.state.environments ?? [];
        const adapter = SimpleListAdapter(environments, environment => _jsx(_Fragment, { children: environment.item.label }));
        return _jsx(TS_PropRenderer.Vertical, { label: 'Environments', children: _jsx(TS_DropDown, { adapter: adapter, selected: this.state.selectedEnvironment, onSelected: selectedEnvironment => {
                    this.reDeriveState({ selectedEnvironment });
                } }) });
    };
    render_LeftPanel_FacilityDD = () => {
        const facilities = this.state.facilities ?? [];
        const adapter = SimpleListAdapter(facilities, facility => _jsx(_Fragment, { children: facility.item.name }));
        return _jsx(TS_PropRenderer.Vertical, { label: 'Facilities', children: _jsx(TS_DropDown, { adapter: adapter, selected: this.state.selectedFacility, onSelected: selectedFacility => {
                    this.reDeriveState({ selectedFacility });
                } }) });
    };
    render_LeftPanel_PatientDD = () => {
        const patients = this.getAvailablePatients();
        const adapter = SimpleListAdapter(patients, patient => _jsx(_Fragment, { children: patient.item.label }));
        return _jsx(TS_PropRenderer.Vertical, { label: 'Patient', children: _jsx(TS_DropDown, { disabled: !patients.length, adapter: adapter, selected: this.state.selectedPatient, onSelected: selectedPatient => {
                    storage_LastSelectedPatient.set(selectedPatient);
                    this.setState({ selectedPatient });
                }, placeholder: 'Select Patient' }) });
    };
    renderLeftPanelButtons = () => {
        return _jsxs(LL_V_L, { className: 'page-demo__left-panel-buttons', children: [_jsx(Button, { variant: 'demo-button', onClick: () => this.launchEnvironment(Advisor_UserType_SBOrders), children: "Sandbox - Orders" }), _jsx(Button, { variant: 'demo-button', onClick: () => this.launchEnvironment(Advisor_UserType_SBNLP), children: "Sandbox - NLP" }), _jsx(Button, { variant: 'demo-button', onClick: () => this.launchEnvironment(Advisor_UserType_SBFHIRQuery), children: "Sandbox - FHIR Query" }), _jsx(Button, { variant: 'demo-button', onClick: toggleLogger, children: "Logger" })] });
    };
    //######################### Render - Middle Panel #########################
    renderMiddlePanel = () => {
        const className = _className('page-demo__panels__middle__menu', !this.state.currentlyOpenedTab_PatientId && 'padding');
        return _jsxs(LL_V_L, { className: 'page-demo__panels__middle', children: [this.renderMiddleTitle(), _jsxs(ResizableWrapper, { className: className, storageKeySuffix: 'advisor-demo', children: [this.renderEncounterIFrames(), this.renderMiddleMock()] })] });
    };
    renderEncounterIFrames = () => {
        return this.state.openEncounters.map(encounter => {
            return this.renderIframe(encounter);
        });
    };
    renderIframe = (encounter) => {
        if (!encounter.src)
            return;
        const focused = this.state.currentlyOpenedTab_PatientId === encounter.patientId;
        const style = focused ? {} : { display: 'none' };
        return _jsx("iframe", { onClick: e => stopPropagation(e), id: getiFrameId(encounter.patientId), src: encounter.src, className: 'advisor-frame', style: style, ref: focused ? this.iframeRef : undefined }, encounter.patientId);
    };
    renderMiddleTitle = () => {
        const className = _className('page-demo__panels__middle__title-item', this.state.openEncounters.length > 0 && 'selected');
        return _jsxs(LL_H_C, { className: 'page-demo__panels__middle__title', children: [_jsx(ICONS.demo_arrows.component, { style: { height: '30px', width: '40px' } }), _jsx("div", { className: 'page-demo__panels__middle__title-item', children: "Chart Review" }), _jsx("div", { className: 'page-demo__panels__middle__title-item', children: "Results Review" }), _jsx("div", { className: className, children: "Quai.MD" }), _jsx("div", { className: 'page-demo__panels__middle__title-item', children: "Triage" }), _jsx("div", { className: 'page-demo__panels__middle__title-item', children: "Orders" }), _jsx("div", { className: 'page-demo__panels__middle__title-item', children: "My Note" }), _jsx("div", { className: 'page-demo__panels__middle__title-item', children: "Workup" }), _jsx("div", { className: 'page-demo__panels__middle__title-item', children: "Discharge" })] });
    };
    renderMiddleMock = () => {
        const openEncounters = this.state.openEncounters;
        if (openEncounters.length > 0 && this.state.currentlyOpenedTab_PatientId) // If we have any open encounters, show the iframe instead of the mock panel
            return;
        return _jsx(Demo_MockMiddlePanel, { children: _jsx(Launcher_EHR, { launchEHR: () => this.launchEnvironment() }) });
    };
    //######################### Render - Right Panel #########################
    renderRightPanel = () => {
        return _jsxs(LL_V_L, { className: 'page-demo__panels__right', children: [_jsxs(LL_H_C, { className: 'page-demo__panels__right__title', children: [_jsx(ICONS.demo_gear.component, {}), _jsx(ICONS.demo_dotMenu.component, {})] }), _jsxs(LL_V_L, { className: 'page-demo__panels__right__menu', children: [_jsx("div", { className: 'page-demo__panels__right__menu__title', children: "Orders" }), _jsxs(LL_H_C, { className: 'page-demo__panels__right__menu__actions', children: [_jsx(LL_H_C, { className: 'page-demo__panels__right__menu__action', children: "Manage Orders" }), _jsx("div", { className: 'page-demo__panels__right__menu__actions-sep' }), _jsxs(LL_H_C, { className: 'page-demo__panels__right__menu__action', children: ["Order Sets", _jsx(ICONS.demo_dotMenu.component, {})] })] })] })] });
    };
}
//# sourceMappingURL=Page_Demo_NEW.js.map